<div class="row">
    @for (variableAlarm of variableAlarms; track $index) {
        <div class="col-sm-12 col-md-6 col-lg-4 pb-3">
            <div class="card mb-3">
                <div
                    class="card-title tile-header me-0 ps-3"
                    style="display: grid; grid-template-columns: 1fr 50px; word-break: break-word">
                    <h3 class="d-inline-block w-100 me-0 pt-2">
                        @if (variableAlarm.alarmName) {
                            {{ variableAlarm.alarmName }}
                        } @else {
                            {{ 'common_Untitled' | translate }}
                        }
                    </h3>
                    <div class="p-1 float-end" style="width: fit-content">
                        <div ngbDropdown placement="bottom-right">
                            <button
                                class="btn btn-link"
                                id="dropdownMeterActions"
                                ngbDropdownToggle
                                style="float: right">
                                <i class="bi bi-three-dots-vertical"></i>
                            </button>
                            <div ngbDropdownMenu>
                                <button
                                    ngbDropdownItem
                                    (click)="editAlarm.emit(variableAlarm.deviationNotificRuleId)">
                                    {{ 'common_Edit' | translate }}
                                </button>
                                <button
                                    ngbDropdownItem
                                    (click)="duplicateAlarm.emit(variableAlarm)">
                                    {{ 'monitoring_duplicate' | translate }}
                                </button>
                                <button
                                    ngbDropdownItem
                                    (click)="deleteVariableAlarm.emit(variableAlarm)">
                                    {{ 'common_Delete' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    @if (variableAlarm.meterCriteriaMismatch) {
                        <div class="m-0 text-warning">
                            <i class="bi bi-exclamation-circle-fill"></i>
                            {{ 'consumption-agents_Meter-list-must-be-updated' | translate }}
                        </div>
                    } @else {
                        <div class="m-0 text-success">
                            <i class="bi bi-check-circle-fill"></i>
                            {{ 'common_All_connected_devices_supported' | translate }}
                        </div>
                    }
                    <ul class="list-group list-group-flush description-list w-100">
                        <li class="list-group-item">
                            <span>{{ 'properties_usage' | translate: 'online' : 'systems' }}</span>
                            <span class="text-nowrap">
                                {{ variableAlarm.usageTranslated }}
                            </span>
                        </li>
                        <li class="list-group-item">
                            <span>{{ 'properties_unit' | translate: 'online' : 'systems' }}</span>
                            <span class="text-nowrap">
                                {{ variableAlarm.unitTranslated }}
                            </span>
                        </li>
                    </ul>

                    <div class="text-end">
                        <button
                            (click)="editAlarm.emit(variableAlarm.deviationNotificRuleId)"
                            class="btn btn-link">
                            {{ 'common_Edit' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    } @empty {
        <div class="col-12">
            <div class="alert alert-warning text-center m-3" role="alert">
                {{
                    ('table_NO_DATA_FROM_SOURCE' | translate: 'online' : 'common')
                        .replace('{0}', 'monitoring_Variable-alarms' | translate)
                        .replace('{1}', 'monitoring_create-variable-alarm' | translate)
                }}
            </div>
        </div>
    }
</div>
